<template>
  <div class="pdf-page">
    <!-- 准考证区域 -->
    <div
      ref="imgCard"
      class="box box4"
      style="width: 100%; max-width: 800px; margin: 0 auto"
    >
      <div v-html="dzContentTitle.content" class="content-title"></div>
      <table class="table">
        <tr>
          <th class="label">姓名：</th>
          <td style="width: 20%">{{ info.name }}</td>
          <th class="label">性别：</th>
          <td style="width: 20%">{{ info.sex }}</td>
          <td rowspan="4">
            <!-- 图片添加加载容错 -->
            <img :src="info.piclink" style="width: 200px; object-fit: cover" />
          </td>
        </tr>
        <tr>
          <th class="label">身份证号：</th>
          <td style="width: 20%">{{ info.id_card }}</td>
          <th class="label">准考证号：</th>
          <td style="width: 20%">{{ examItem.show_pass_number }}</td>
        </tr>
        <tr>
          <th class="label">考点名称：</th>
          <td colspan="3">{{ examItem.show_exam_name }}</td>
        </tr>
        <tr>
          <th class="label">考点地址：</th>
          <td colspan="3">{{ examItem.show_exam_add }}</td>
        </tr>
        <tr>
          <th class="label">考场号：</th>
          <td style="width: 25%">{{ examItem.show_exam_number }}</td>
          <th class="label">座位号：</th>
          <td colspan="2" style="width: 50%">
            {{ examItem.show_seat_number }}
          </td>
        </tr>
        <tr>
          <th class="label">岗位编号：</th>
          <td style="width: 25%">{{ info.position_no }}</td>
          <th class="label">报考岗位：</th>
          <td colspan="2" style="width: 50%">{{ info.position_applied }}</td>
        </tr>
        <tr>
          <th class="label">考试时间：</th>
          <td colspan="4">{{ examItem.show_exam_time }}</td>
        </tr>
        <tr class="notice">
          <td colspan="5">敬请诚信参考，反对考试作弊，共同维护公平公正！</td>
        </tr>
      </table>
      <div v-html="dzContent.content" class="content-desc"></div>
      <div style="height: 10px"></div>
    </div>

    <!-- 报名信息表区域 -->
    <div
      ref="imgCard2"
      class="box box3"
      style="width: 100%; max-width: 800px; margin: 20px auto 0"
    >
      <div class="title2" style="margin-bottom: 10px">考生报名信息表</div>
      <table class="table">
        <tr>
          <th class="label">姓名</th>
          <td colspan="2" style="width: 20%">{{ info.name }}</td>
          <th class="label">性别</th>
          <td colspan="2" style="width: 20%">{{ info.sex }}</td>
          <td colspan="3" rowspan="7">
            <img :src="info.piclink" style="width: 200px; object-fit: cover" />
          </td>
        </tr>
        <tr>
          <th class="label">婚姻状况</th>
          <td colspan="2" style="width: 20%">{{ info.marital_status }}</td>
          <th class="label">政治面貌</th>
          <td colspan="2" style="width: 20%">{{ info.political_status }}</td>
        </tr>
        <tr>
          <th class="label">户籍所在地</th>
          <td colspan="2" style="width: 20%">{{ info.domicile }}</td>
          <th class="label">身份证号</th>
          <td colspan="2" style="width: 20%">{{ info.id_card }}</td>
        </tr>
        <tr>
          <th class="label">学历</th>
          <td colspan="2" style="width: 20%">{{ info.edu }}</td>
          <th class="label">所学专业</th>
          <td colspan="2" style="width: 20%">{{ info.right_major }}</td>
        </tr>
        <tr>
          <th class="label">毕业院校</th>
          <td colspan="2" style="width: 20%">
            {{ formList[formListShow] ? formList[formListShow].yx : "" }}
          </td>
          <th class="label">学位</th>
          <td colspan="2" style="width: 20%">
            {{ formList[formListShow] ? formList[formListShow].xw : "" }}
          </td>
        </tr>
        <tr>
          <th class="label">出生日期</th>
          <td colspan="2" style="width: 20%">{{ info.birth }}</td>
          <th class="label">联系电话</th>
          <td colspan="2" style="width: 20%">{{ info.tel }}</td>
        </tr>
        <tr>
          <th class="label">联系地址</th>
          <td colspan="5">
            {{ info.province }}{{ info.city }} {{ info.area }}
            {{ info.address }}
          </td>
        </tr>
        <tr>
          <th class="label">专业技术职务<br />(职称)</th>
          <td colspan="2" style="width: 120px">{{ info.current_title }}</td>
          <th class="label">现有从业资格证书，等级证书</th>
          <td
            colspan="5"
            style="max-width: 400px; text-align: left; word-break: break-all"
          >
            {{ info.current_professional_certification }}
          </td>
        </tr>
        <tr style="height: 130px">
          <th class="label">工作和学习经历</th>
          <td colspan="8" style="text-align: left; word-break: break-all">
            {{ info.work_experience }}
          </td>
        </tr>
        <tr>
          <th class="label">报考城市</th>
          <td colspan="2" style="width: 120px">{{ info.a_city }}</td>
          <th class="label">报考岗位</th>
          <td colspan="2" style="width: 120px">{{ info.position_applied }}</td>
          <th class="label">岗位编号</th>
          <td colspan="2" style="width: 120px">{{ info.position_no }}</td>
        </tr>

        <tr style="height: 130px">
          <th class="label">报名人员承诺</th>
          <td colspan="8" style="text-align: left; word-break: break-all">
            <div class="dz_td_text">
              <div>
                我已详细阅读了招考公告、职位相关要求和填表说明，确信符合报考条件及职位要求。本人保证填报资料真实准确，如因个人填报信息失实或不符合报考条件和职位要求而被取消考录资格的，由本人负责。
              </div>
              <div style="display: flex; margin-top: 10px">
                <div style="margin-right: 160px">报名人员签名:</div>
                <div>
                  <span>日期:</span><span>年</span><span>月</span
                  ><span>日</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr style="height: 130px">
          <th class="label">审查人员承诺</th>
          <td colspan="8" style="text-align: left; word-break: break-all">
            <div class="dz_td_text">
              <div>
                本人已认真审查本报名表，并根据招聘公告、报考指南和岗位要求对报考人员进行审查，愿意对上述审查意见负责。
              </div>
              <div style="display: flex; margin-top: 10px">
                <div style="margin-right: 160px">审查人员签名:</div>
                <div>
                  <span>日期:</span><span>年</span><span>月</span
                  ><span>日</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr style="height: 130px">
          <th class="label">审查意见</th>
          <td colspan="8" style="text-align: left"></td>
        </tr>
      </table>
      <div style="height: 10px"></div>
    </div>
  </div>
</template>

<script>
// 降级使用兼容版本，避免webpack解析错误
import html2pdf from "html2pdf.js";

export default {
  name: "PdfGenerator",
  data() {
    return {
      dzContentTitle: { content: "" }, // 初始化空内容，避免渲染报错
      dzContent: { content: "" },
    };
  },
  props: {
    formListShow: {
      type: [Boolean, Number], // 修正类型：可能是索引值，不一定是布尔
      default: 0,
    },
    info: {
      type: Object,
      default: () => ({}), // 空对象初始化，避免取值报错
    },
    examItem: {
      type: Object,
      default: () => ({}),
    },
    formList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async getContent(id, key) {
      try {
        const res = await this.$api.getUser.get_agreement({ id: id });
        if (res.code === 200) {
          this[key] = res.result;
        } else {
          this.$toast.fail(res.result || "内容加载失败");
        }
      } catch (err) {
        console.error("获取内容失败：", err);
        this.$toast.fail("内容加载异常");
      }
    },
    // 生成PDF方法（增加异步等待，确保内容渲染完成）
    async generatePdf(fnc, text) {
      if (!this.$refs[fnc]) {
        this.$toast.fail("未找到要生成的内容区域");
        return;
      }
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "生成中...",
      });

      // 等待异步内容和图片加载完成
      await new Promise((resolve) => setTimeout(resolve, 800));

      // 配置项优化：适配A4尺寸，解决内容截断
      const pdfOptions = {
        margin: 5, // 减小边距，适配800px宽度
        filename: `${text}_${Date.now()}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 3, // 提高清晰度（3倍缩放）
          useCORS: true,
          logging: false, // 关闭日志
          letterRendering: true, // 优化文字渲染
          allowTaint: true, // 允许跨域图片（关键！）
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
          compress: true, // 压缩PDF体积
        },
      };

      try {
        // 执行生成
        html2pdf().set(pdfOptions).from(this.$refs[fnc]).save();
        setTimeout(() => {
          toast.clear();
          this.$toast.success("PDF生成并下载成功！");
        }, 800);
      } catch (err) {
        toast.clear();
        this.$toast.fail("PDF生成失败，请重试");
      }
    },
  },
  created() {
    this.getContent(5464, "dzContentTitle");
    this.getContent(5463, "dzContent");
  },
  // 可选：监听异步内容加载完成，提示用户可生成
  watch: {
    dzContentTitle: {
      handler(val) {
        if (val.content) console.log("标题内容加载完成");
      },
      deep: true,
    },
  },
};
</script>

<!-- 去掉scoped，避免样式穿透问题；或用/deep/穿透 -->
<style lang="less">
.pdf-page {
  background: #fff;
  padding: 10px;
}

.box {
  background-color: #fff;
  padding: 10px 0;
}

.table {
  width: 100%;
  border-collapse: collapse !important; // 强制合并边框
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
}

.table th.label {
  width: 90px;
}

.box4 {
  .table th,
  .table td {
    min-height: 40px;
  }
}

.table th,
.table td {
  border: 1px solid #000 !important; // 强制显示边框
  padding: 8px !important;
  text-align: center;
  vertical-align: middle; // 垂直居中
}

// 超长文字换行
.table td {
  word-break: break-all;
  white-space: normal;
}

.notice {
  color: #ed6a0c;
  font-weight: 600;
}

.box3 .title2 {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 20px;
  text-align: center;
  width: 100%;
}

.dz_td_text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80px;
  padding: 5px;

  > div:nth-child(2) {
    display: flex;
    > div:nth-child(1) {
      margin-right: 160px;
    }
    > div:nth-child(2) > span {
      margin-right: 60px;
    }
  }
}

// 适配v-html内容的样式
.content-title,
.content-desc {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  font-size: 16px;
}
</style>
